export default __webpack_public_path__ + "static/media/makersplace-white.5d142f89.png";